import { render, staticRenderFns } from "./ReservationOrders.vue?vue&type=template&id=e0f92bfc&scoped=true"
import script from "./ReservationOrders.vue?vue&type=script&lang=js"
export * from "./ReservationOrders.vue?vue&type=script&lang=js"
import style0 from "./ReservationOrders.vue?vue&type=style&index=0&id=e0f92bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f92bfc",
  null
  
)

export default component.exports